// import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";

import { ErrorHandler } from "../core/ErrorApi/ErrorHandler";
import Locale from '@/helper/locale/locale.js';
import LineFunction from "@/helper/facede/LineFunction";
export default {
    methods: {
        errorResponse: function(err, handler) {
            if (handler == null) {
                handler = new ErrorHandler();
            }

            handler.setRouter(this.$router);

            if (this.alertModal) {
                handler.setAlertModal(this.alertModal);
            }

            if (err.response && err.response.data && err.response.data.error) {
                if (err.response.data.error.code == 409 && err.response.data.error.id == 100000) {
                    let lbl = Locale.getLbl();
                    this.alertModal
                        .clearText()
                        .setTitle(lbl.register.err_fruad.title)
                        .setMsg(lbl.register.err_fruad.msg)
                        .setBtnOk(lbl.default.close)
                        .show();
                    this.alertModal.onClickOk(() => {
                        let line = new LineFunction();
                        let liffId = line.getLiffId();
                        line.init(liffId).then(() => {
                            line.closeWindow();
                        });
                    });
                } else {
                    var error = err.response.data.error;
                    handler.errorCase(error);
                }
            } else {
                if (this.alertModal) {
                    this.alertModal
                        .setTitle("เกิดข้อผิดพลาด")
                        .setMsg("ไม่สามารถเชื่อมต่ออินเตอร์เน็ต<br/>กรุณาลองใหม่อีกครั้ง")
                        .show();
                    handler.errorCode(err);
                } if (this.modalController.alertModal) {
                    this.modalController.alertModal
                        .setTitle("เกิดข้อผิดพลาด")
                        .setMsg("ไม่สามารถเชื่อมต่ออินเตอร์เน็ต<br/>กรุณาลองใหม่อีกครั้ง")
                        .show();
                }
            }
        },
    },
}
